module.exports = __webpack_public_path__ + "img/playwin.7d6518e7.png";